module.exports = __webpack_public_path__ + "assets/black-up-arrow.1336bc84f70b136df4827126ed17c276.svg";